import { Component, Vue } from 'vue-property-decorator';

@Component
export default class DebugComponent extends Vue {

    public hidden = false;

    public get shouldDebug(): boolean {

        return process.env.NODE_ENV === 'development';
    }
}
